export function observacionCursoNormalize(row) {
    return {
        idObservacion: row.idObservacion ?? row.IdObservacion ?? row['IdObservacion'] ?? 0,
        idPeticion: row.idPeticion ?? row.IdPeticion ?? row['IdPeticion'] ?? 0,
        observacion: row.observacion ?? row.Observacion ?? row['Observacion'] ?? '',
        activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    };
}
